import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2TourTableWinDialogProperties extends BasicDialogProperties {
    public functionOk: Function;
    public round: number = 0;

    constructor(round: number, functionOk: Function = null) {
        super();
        this.functionOk = functionOk;
        this.round = round;
    }
}
